import React from 'react'
import Icon from './'

export default props => (
  <Icon viewBox="0 0 16.933 16.933" {...props}>
    <path d="M8.037 5.821l-.881 3.418-.357-1.702-.543 2.32.293 1.255h1.102l.816-3.067.815 3.067h1.102l1.24-5.291h-1.13l-.716 3.418-.882-3.418zM1.13 5.82l.716 3.419.881-3.418h.86l.88 3.418.717-3.418h1.13l-1.24 5.292H3.972l-.815-3.067-.816 3.067H1.24L0 5.82h1.13zM13.347 5.821l-.881 3.418-.357-1.702-.544 2.32.294 1.255h1.102l.816-3.067.815 3.067h1.102l1.24-5.291h-1.13l-.716 3.418-.882-3.418z" />
  </Icon>
)
